import type { TopGiftsListParams, TopGiftsResult } from "@/interfaces/reportsTopGifts";
import { apiClient } from "@/lib/apiClient";

/**
 * GET /reports/top-gifts -- the Top Gifts report's ONE endpoint: ranked gift rows for the active
 * campaign/date filters, plus the campaign filter options when `includeFilterOptions` is set.
 */
export async function fetchTopGifts(params?: TopGiftsListParams): Promise<TopGiftsResult> {
  const query: Record<string, string> = {};
  if (params?.campaign_id?.length) query.campaign_id = params.campaign_id.join(",");
  if (params?.redeemedFrom) query.redeemedFrom = params.redeemedFrom;
  if (params?.redeemedTo) query.redeemedTo = params.redeemedTo;
  if (params?.includeFilterOptions) query.includeFilterOptions = "true";

  const { data } = await apiClient.get<TopGiftsResult>("/reports/top-gifts", { params: query });
  return data;
}
